module.exports = __webpack_public_path__ + "static/media/vero-beach-dodgers.6ca797d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/vero-beach-dodgers.png
// module id = 89
// module chunks = 0